import { getChangeRequestsProgress } from '@/services/buyer-dashboard';
import { IState } from '@/state/IState';
import { Dispatch } from 'redux';
import { setBuyerChangeRequests } from './actions';

// export const loadBuyerCommentThreads = async (dispatch) => {
//     const residentialUnitId = useSelector((state: IState) => state.buyer.permissions!.residentialUnitId);
//     const data = await getBuyerCommentThreads(residentialUnitId);
//     dispatch(setBuyerCommentThreads(data));
// };

export function loadBuyerChangeRequests() {
    return async function (dispatch: Dispatch, getState: () => IState) {
        const residentialUnitId = getState().buyer.permissions!.residentialUnitId;
        const data = await getChangeRequestsProgress(residentialUnitId);
        dispatch(setBuyerChangeRequests(data));
    };
}